var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76688 10.25H16.2331L16.6779 8.01112L17 5.15873C17 2.04374 14.2499 0.88075 12 3.28706C9.75008 0.88075 7 2.04374 7 5.15875L7.32205 8.01111L7.76688 10.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5136 11.75H7.48643L4.09604 17.7668C3.93596 18.0509 3.97895 18.4032 4.2029 18.6424C8.39297 23.1192 15.607 23.1192 19.7971 18.6424C20.021 18.4032 20.064 18.0509 19.904 17.7668L16.5136 11.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDress);
export default __webpack_public_path__ + "static/media/dress.49e7d7e5de54c1346d1a19a625661b45.svg";
export { ForwardRef as ReactComponent };